import React from 'react';
import IndividImg from '../../imgs/1on1_instruction.jpg'

const OneonOne: React.FC = () => {
  return (
    <div className="min-h-screen bg-lighttan pt-28">
        <h1 className="text-4xl font-bold text-darkgreentext mb-12 text-center">
          One on One Sessions
        </h1>
        <div className="flex items-center justify-center bg-lighttan">
            <img
            src={IndividImg}
            alt="Breathwork Class 1"
            className="mx-auto w-full max-w-md h-96 rounded-lg shadow-lg object-cover object-center"
            />
        </div>

      <div className="max-w-4xl mx-auto px-8 py-16 text-center">
        <p className="text-xl text-darkgreentext leading-relaxed">
          Learn from Sean on the elements involved in Motiv8 Living to lead a happy and healthy life!
        </p>
      </div>
      <div className="flex justify-center pb-8">
          <a
          href='https://www.motiv8living.com/contact'
          className="px-6 py-3 bg-darkgreentext text-white rounded-lg font-bold text-xl hover:bg-greenbutton transition"
        >
          Contact Us to Schedule 
        </a>
      </div>
    </div>
  );
};

export default OneonOne;
